import { render } from "./editMeals.vue?vue&type=template&id=228e5822&scoped=true"
import script from "./editMeals.vue?vue&type=script&lang=js"
export * from "./editMeals.vue?vue&type=script&lang=js"

import "./editMeals.vue?vue&type=style&index=0&id=228e5822&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228e5822"]])

export default __exports__